import apiClient from "./apiClient";

const produzioniFormAPI = {

  createStepFormData: (data) =>
    apiClient.post(`/produzioni/step-form-data`, data),

  updateStepFormData: (id, data) =>
    apiClient.put(`/produzioni/step-form-data/${id}`, data),

  deleteStepFormRow: ({id, formName}) =>
    apiClient.delete(`/produzioni/step-form-delete/${formName}/${id}`),

  getSingleStepFormData: (payload) =>
    apiClient.get(`/produzioni/get-step-form-data`,{ params: payload }),

  getRaccolta: () =>
    apiClient.get(`/produzioni/get-raccolta`),

  getCertificazioni: () =>
    apiClient.get(`/produzioni/get-certificazioni?company_id=${localStorage.getItem('company_id')}`),

  getModApplicazione: () =>
    apiClient.get(`/produzioni/get-mod-di-applicazione`),

  getSiccurezza: () =>
    apiClient.get(`/produzioni/get-siccurezza`),

  getTipoContenitore: () =>
    apiClient.get(`/produzioni/get-tipo-di-contenitore`),

  getProdotto: () =>
    apiClient.get(`/produzioni/get-prodotto`),

  getVarientaDelluva: () =>
    apiClient.get(`/produzioni/get-varienta-delluva`),

  getVarientaVigneto: () =>
    apiClient.get(`/produzioni/get-varienta-vigneto`),

  getFlagApi : (payload)=>
      apiClient.get(`produzioni/get-production-flag`,{ params: payload })
};

export default produzioniFormAPI;
